import React from 'react'
import { useForm } from 'react-hook-form'
import Form from '../../components/Form'
import FormItem from '../../components/Form/FormItem'
import InputText from '../../components/Inputs/InputText'

const ChangePasswordTenant : React.FC<IChangePassword> = ({onSubmit, tenantUser}) => {
  const form = useForm({
    defaultValues: tenantUser
  })

  return (
    <Form form={form} onSubmit={() => {}} classes="gap-x-5">
      <FormItem
        name="realName"
        classes="md:col-span-5 col-span-12"
        rules={{ required: 'Es necesario una razón social' }}
      >
        <InputText small label="Nombre completo" disableInput />
      </FormItem>

      <FormItem
        name="email"
        classes="md:col-span-7 col-span-12"
        rules={{ required: 'Es necesario una razón social' }}
      >
        <InputText small label="Correo electrónico" disableInput />
      </FormItem>

      <div className="col-span-12 mt-2" style={{textAlign: 'end'}}>
        <label
          className="text-sm text-primary cursor-pointer font-medium"
          // onClick={() => onClickCard(idx)}
          onClick={() => {
            onSubmit(form?.getValues())
          }}
        >
          Cambiar contraseña
        </label>
      </div>
    </Form>
  )
}

interface IChangePassword {
    onSubmit: (values) => void
    tenantUser: any
}

export default ChangePasswordTenant
